import { ActivityEntity } from '../entities/activity-entity';

export default class State {
  current_job_type_id = '';

  items: Array<ActivityEntity> = [];
}
